import apiSlice from "../api/apiSlice";

export const hpApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getWaterMassUsageForecastByCommunityIdPagination: builder.query({
      query: ({ limit, page, date, time, resourceId, communityId, sortColumn, sortDirection }) => ({
        url:
          `/communities/${communityId}/water_mass_usage_forecast/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${resourceId ? `&resource_id=${resourceId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "HP", id: "LIST" }],
    }),
    getOutsideTempLoadsByCommunityIdPagination: builder.query({
      query: ({ limit, page, date, time, resourceId, communityId, sortColumn, sortDirection }) => ({
        url:
          `/communities/${communityId}/outside_temp_loads/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${resourceId ? `&resource_id=${resourceId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "HP", id: "LIST" }],
    }),
    /* POST */
    addWaterMassUsageForecast: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/water_mass_usage_forecast/file_upload`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "HP", id: "LIST" }],
    }),
    addOutsideTempLoads: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/outside_temp_loads/file_upload`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "HP", id: "LIST" }],
    }),
  }),
});

export const {
  useAddWaterMassUsageForecastMutation,
  useGetWaterMassUsageForecastByCommunityIdPaginationQuery,
  useAddOutsideTempLoadsMutation,
  useGetOutsideTempLoadsByCommunityIdPaginationQuery,
} = hpApiSlice;
